<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M26 23h-9v-2h7.94a2 2 0 001.49-.67 2 2 0 00.5-1.56A11 11 0 0017 9.05V7h3a1 1 0 000-2h-8a1 1 0 000 2h3v2.05a11 11 0 00-9.93 9.72 2 2 0 00.5 1.56 2 2 0 001.49.67H15v2H6a1 1 0 000 2h20a1 1 0 000-2zM7.06 19a9 9 0 0117.88 0z"/><path d="M12.67 12.72a8.09 8.09 0 00-3.88 3.8.5.5 0 00.24.67.54.54 0 00.21 0 .48.48 0 00.45-.19 7.05 7.05 0 013.4-3.33.5.5 0 00.25-.66.52.52 0 00-.67-.29zM15.39 12c-.27 0-.53.06-.79.1a.5.5 0 00.08 1h.09c.23 0 .46-.07.7-.09a.5.5 0 00-.08-1z"/></svg>